import React, { useState, useRef, useEffect } from 'react';
import DetectDevice from './DeviceDetector';
import { useMap } from 'react-leaflet/hooks';
import { IoIosClose, IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import { BsInstagram, BsTwitter, BsTiktok } from 'react-icons/bs';
import '../styles/information.css';
import { isSafari } from 'react-device-detect';
import { useSelector } from 'react-redux';
import {
  IoIosAdd,
  IoIosRemove,
  IoIosArrowUp,
  IoIosArrowDown,
} from 'react-icons/io';
import '../styles/listview.css';
import token_dict from '../data/token_dict.json';
import ownership_full from '../data/availability_list.json';
import { Alchemy, Network } from 'alchemy-sdk';
import contract from './redux/config/config.json';
import { selectQueried } from './MyMap.js';
import polygonJson from '../data/geo_json_string.json';

const contractABI = require('./contract-abi.json');
const { createAlchemyWeb3 } = require('@alch/alchemy-web3');

var alch_network;
var alch_key;
var alchemyKey;
var contractAddress;
var opensea_key;

if (contract.NETWORK.ID == 1) {
  // Initialization
  alch_key = contract.ALCH_KEY;
  alch_network = Network.ETH_MAINNET;
  alchemyKey = contract.ALCH_KEY_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS);
  opensea_key = contract.OPENSEA_KEY;
}
if (contract.NETWORK.ID == 5) {
  // Initialization
  alch_key = contract.ALCH_KEY_TEST;
  alch_network = "eth-sepolia"; //Network.ETH_SEPOLIA;
  alchemyKey = contract.ALCH_KEY_TEST_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
  opensea_key = contract.OPENSEA_KEY;
}

const alc_config = {
  apiKey: alch_key,
  network: alch_network,
};
const alchemy = new Alchemy(alc_config);
const alch_web3 = createAlchemyWeb3(alchemyKey);

let arr = [];
for (let i = 0; i < 1000; i++) {
  arr.push(i);
}

const TileSlider = ({ onChange }) => {
  const [value, setValue] = useState([0, 67]);

  const handleClick = (e) => {
    if (e.target.className !== 'rc-slider-handle') {
      e.stopPropagation();
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    onChange(newValue); // Call the onChange prop with the new value
  };

  const handleMinChange = (event) => {
    const newValue = Number(event.target.value);
    if (newValue <= value[1]) {
      setValue([newValue, value[1]]);
      onChange([newValue, value[1]]);
    }
  };

  const handleMaxChange = (event) => {
    const newValue = Number(event.target.value);
    if (newValue >= value[0]) {
      setValue([value[0], newValue]);
      onChange([value[0], newValue]);
    }
  };

  return (
    <div className="filter-ref" onClick={handleClick} style={{paddingLeft:"0px", paddingRight:"30px"}}>
      <input
        type="number"
        min={0}
        max={67}
        value={value[0]}
        onChange={handleMinChange}
      />
      <span style={{ fontSize: 20}}>-</span>
      <input
        type="number"
        min={0}
        max={67}
        value={value[1]}
        onChange={handleMaxChange}
      />
    </div>
  );
};

const PixelSlider = ({ onChange }) => {
  const [value, setValue] = useState([0, 264670500]);

  const handleClick = (e) => {
    if (e.target.className !== 'rc-slider-handle') {
      e.stopPropagation();
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    onChange(newValue); // Call the onChange prop with the new value
  };

  const handleMinChange = (event) => {
    const newValue = Number(event.target.value);
    if (newValue <= value[1]) {
      setValue([newValue, value[1]]);
      onChange([newValue, value[1]]);
    }
  };

  const handleMaxChange = (event) => {
    const newValue = Number(event.target.value);
    if (newValue >= value[0]) {
      setValue([value[0], newValue]);
      onChange([value[0], newValue]);
    }
  };

  return (
    <div className="filter-ref" onClick={handleClick} style={{paddingLeft:"0px", paddingRight:"30px"}}>
      <input
        type="number"
        min={0}
        max={264670500}
        value={value[0]}
        onChange={handleMinChange}
      />
      <span style={{ fontSize: 20}}>-</span>
      <input
        type="number"
        min={0}
        max={264670500}
        value={value[1]}
        onChange={handleMaxChange}
        style={{width:"90px"}}
      />
    </div>
  );
};

export const Info_pricing = ({
  setProjectInfo,
  setSidebar,
  masterTile,
  currentPrompt,
  gridOverlay,
  setMasterTile,
  setSidebarTitle,
  ownershipUpdated,
  setCurrentPrompt,
  setTilePreview,
  listViewExpanded,
  setlistViewExpanded,
  ownership,
  setOwnership,
}) => {
  const [expandables, setExpandables] = useState([1, 0, 0, 0, 0, 0, 0]);
  const map = useMap();
  const blockchain = useSelector((state) => state.blockchain);
  const [selectedItem, setSelectedItem] = useState(null);
  const [mousedOverItem, setMousedOverItem] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [selectedClasses, setSelectedClasses] = useState([0,0,0,0]);
  const [tileRange, setTileRange] = useState({ min: 0, max: 67 });
  const [pixelRange, setPixelRange] = useState({ min: 0, max: 264670500 });
  const [filtersOpened, setFiltersOpened] = useState(1);
  const listViewRef = useRef(null);
  const [items, setItems] = useState([]);
  const [listedTokens, setListedTokens] = useState([]);
  const [listedTokensPrices, setListedTokensPrices] = useState({});
  const [ppFloor, setppFloor] = useState(null);
  const [ppFloorToken, setppFloorToken] = useState(null);
  const [sortAscending, setSortAscending] = useState(false);
  const [sortListedPrice, setSortListedPrice] = useState(false);
  const [sortListedPriceRaw, setSortListedPriceRaw] = useState(false);
  const [sortType, setSortType] = useState('tile');

  const selectQueriedClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    queryNumObject,
    setTilePreview,
  }) =>
    selectQueried({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      queryNumObject,
      setTilePreview,
    });

  function setLink(curTile) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://opensea.io/assets/ethereum/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://testnets.opensea.io/assets/goerli/';
    }
    let link_with_contract = link_base.concat(String(contractAddress));
    let link2 = link_with_contract.concat('/');
    let full_link = link2.concat(curTile);
    return full_link;
  }

  useEffect(() => {
    var urlId = '/todem/info';
    window.history.pushState('', '', '' + urlId);
    return () => {
      var urlId = '/todem/';
      window.history.pushState('', '', '' + urlId);
      let tileNum = masterTile.masterTile.name;
      if (!isNaN(Number(tileNum.split('-')[1]))) {
        urlId += tileNum.split('-')[1].padStart(4, '0');
        if (currentPrompt) {
          urlId += '.' + currentPrompt[0];
        }
        window.history.pushState('', '', '' + urlId);
      }
    };
  }, []);

  //const map = useMap();

  map.smoothWheelZoom.disable();
  map.scrollWheelZoom.disable();
  map.dragging.disable();

  // This is the color that fills notch space on mobile
  useEffect(() => {
    document.body.style.backgroundColor = 'white';
    return () => {
      document.body.style.backgroundColor = 'white';
    };
  });

  function getMintPrice(tokenId) {
      return (Number(tokenId) * 250000000000) / 1000000000000000000;
  }

  async function fetchItems() {
    const promises = arr.map(async (num) => {
      let num_padded = num.toString().padStart(4, '0');
      let price = getMintPrice(token_dict[num_padded]);
      var listedPrice = null; //0.00000025
      var PerPixelPrice = null; 

      if (listedTokens.includes(token_dict[num_padded].toString())){
        listedPrice = listedTokensPrices[token_dict[num_padded].toString()] 
        PerPixelPrice = listedTokensPrices[token_dict[num_padded].toString()] 
      }
      else {
        if (ownership[token_dict[num_padded]] !== 0){
          listedPrice = null
          PerPixelPrice = null
        }
        else{
          PerPixelPrice = 0.00000025
        }
      }

      let status =
        ownership[token_dict[num_padded]] === 0
          ? 'Uminted'
          : ownership[token_dict[num_padded]] === 1
          ? 'Minted'
          : ownership[token_dict[num_padded]] === 2
          ? 'Yours'
          : ownership[token_dict[num_padded]] === 3
          ? 'Listed'
          : 'Unknown';
      return (selectedStatus === 'All' ||
        selectedStatus === status || (selectedStatus === 'Listed' && listedTokens.includes(token_dict[num_padded].toString())) || 
        (selectedStatus === 'Minted' && status === 'Yours')) &&
        ((price >= tileRange.min && price <= tileRange.max && (!sortListedPrice&&!sortListedPriceRaw)) || 
        (listedPrice*token_dict[num_padded] >= tileRange.min && listedPrice*token_dict[num_padded] <= tileRange.max && (sortListedPrice|| sortListedPriceRaw))) 
        && (token_dict[num_padded] >= pixelRange.min && token_dict[num_padded] <= pixelRange.max)
        ? {
            image: `https://www.latentculture.com/tohm/thumbs/TODEM.thumb.${num_padded}.jpg`,
            name: num_padded,
            price: price.toFixed(5),
            pixelPrice:PerPixelPrice,
            listedPrice: listedPrice, 
            status: status,
            class: polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1],
          }
        : null;
    });

    var items = await Promise.all(promises);
    if(!selectedClasses[0]&&!selectedClasses[1]&&!selectedClasses[2]&&!selectedClasses[3]){
      items = items.filter((item) => item !== null);
    }
    else{
      var pickedClasses = []
      if(selectedClasses[0]){pickedClasses.push('A')}
      if(selectedClasses[1]){pickedClasses.push('B')}
      if(selectedClasses[2]){pickedClasses.push('C')}
      if(selectedClasses[3]){pickedClasses.push('D')}
      items = items.filter((item) => item !== null && pickedClasses.includes(item.class));
    }
    //items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name)); // Sort items
    if(sortListedPriceRaw){
        items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name));
        items.sort((a, b) => (sortAscending ? a.listedPrice*token_dict[a.name] - b.listedPrice*token_dict[b.name] : b.listedPrice*token_dict[b.name] - a.listedPrice*token_dict[a.name]));
    }else if(sortListedPrice){
        items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name));
        items.sort((a, b) => (sortAscending ? a.pixelPrice - b.pixelPrice : b.pixelPrice - a.pixelPrice));
    }else{
        items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name));
    }
    setItems(items);
  }
  async function fetchPixelPrice() {
    const url = 'https://api.opensea.io/v2/listings/collection/todem/all';
    const options = {method: 'GET', headers: {accept: 'application/json', 'X-API-KEY': opensea_key}};
    let listings;
    await fetch(url, options).then(res => res.json()).then(json => listings = json.listings);
    const PixelPrices = [];
    const ListedTokens = [];
    const ListedTokensAndPrices = {};
    for (let listing of listings){
        let listedPrice = listing.price.current.value / 10 ** listing.price.current.decimals
        let listedTokenArea = listing.protocol_data.parameters.offer[0].identifierOrCriteria
        PixelPrices.push(listedPrice / listedTokenArea)
        ListedTokens.push(listedTokenArea)
        ListedTokensAndPrices[listedTokenArea] = listedPrice / listedTokenArea
    }
    setListedTokens(ListedTokens);
    setListedTokensPrices(ListedTokensAndPrices);
    let tempPPFloor = Math.min(...PixelPrices);
    setppFloor(tempPPFloor.toFixed(8));
    let floorTokenID = Object.keys(ListedTokensAndPrices).find(key => ListedTokensAndPrices[key] == tempPPFloor) 
    let floorTokenNum = Object.keys(token_dict).find(key => token_dict[key] == floorTokenID)
    setppFloorToken(floorTokenID)
  }

  useEffect(() => {
    fetchPixelPrice();
  }, [masterTile]);

  useEffect(() => {
    if (selectedItem != masterTile.masterTile.name.split('-')[1]) {
      setSelectedItem(null);
    }
  }, [masterTile]);

  useEffect(() => {
    fetchItems();
  }, [selectedClasses, ownership, ownershipUpdated, selectedStatus, tileRange, pixelRange, sortAscending, sortListedPrice, sortListedPriceRaw]);

  return (
      <>
      <div style={{"fontFamily": "Terminus"}} id="info-pricing-wrapper">
      <h5>TODEM Pricing</h5>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
      Tiles are priced per pixel.
      <span style={{ color: 'rgba(255,255,255,0.8)', paddingLeft:"1px", fontSize:  "16px"}}> Total pixels * 0.00000025 eth = mint price </span>
      <br></br>
      <span style={{ color: 'rgba(255,255,255,0.8)', paddingLeft:"3px", fontSize:  "16px"}}>Mint price per pixel: 0.00000025 | Floor price per pixel: </span>  
      <span className="floorPrice" style={{ cursor: "pointer", color: 'rgba(255,255,255,0.8)',textDecoration: 'underline'}} 
            onClick={() => {
                      window.open(setLink(ppFloorToken), '_blank')
                }}>{ppFloor}
      </span>   
      <div className="filter-options" style={{marginTop:"10px"}}>
      <h6>Filters</h6>
        <div className="radio-buttons-info">
            <label>
              <input
                type="radio"
                value="All"
                checked={selectedStatus === 'All'}
                onChange={(e) => setSelectedStatus(e.target.value) }
                autoComplete="off"
              />
              All
            </label>
            <label>
              <input
                type="radio"
                value="Minted"
                checked={selectedStatus === 'Minted'}
                onChange={(e) => setSelectedStatus(e.target.value)}
                autoComplete="off"
              />
              Minted
            </label>
            <label>
              <input
                type="radio"
                value="Uminted"
                checked={selectedStatus === 'Uminted'}
                onChange={(e) => setSelectedStatus(e.target.value)}
                autoComplete="off"
              />
              Uminted
            </label>
            <label>
              <input
                type="radio"
                value="Yours"
                checked={selectedStatus === 'Yours'}
                onChange={(e) => setSelectedStatus(e.target.value)}
                autoComplete="off"
              />
              Yours
            </label>
            <label>
              <input
                type="radio"
                value="Listed"
                checked={selectedStatus === 'Listed'}
                onChange={(e) => setSelectedStatus(e.target.value)}
                autoComplete="off"
              />
              Listed
            </label>
              <img
                src="https://storage.googleapis.com/opensea-static/Logomark/Logomark-Blue.png"
                alt="Opensea Icon"
                id="opensea"
                style={{
                  filter: 'grayscale(100%)',
                  opacity: 0.4,
                  pointerEvents: 'none',
                  marginTop: "-7px",                  
                  marginLeft: "-33%",
                  width: 16,
                  height: 16,
                }}
                onClick={() => {}}
              ></img>
          </div>
        <div className="grid-container-filter-stuff">
          <div
          className="grid-item-filter-stuff"
            style={{
              marginTop: 5
            }}
          >
            <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: "13px" }}>
              Price Range (eth)
            </span>
            <TileSlider                    
              value={[tileRange.min, tileRange.max]}
              onChange={(value) =>
                setTileRange({ min: value[0], max: value[1] })
              }
            />
          </div>
          <div
          className="grid-item-filter-stuff"
            style={{
              marginTop: 5,
            }}
          >                
            <span style={{color: 'rgba(255,255,255,0.8)', fontSize: "13px"}}>
              Pixel Range (px)
            </span>                  
            <PixelSlider
              value={[pixelRange.min, pixelRange.max]}
              onChange={(value) =>
                setPixelRange({ min: value[0], max: value[1] })
              }
            />
          </div>
        <div  
        className="grid-item-filter-stuff" 
            style={{
              marginTop: 5
            }}>
            <span style={{color: 'rgba(255,255,255,0.8)', fontSize: "13px" }}>
              Class
            </span> 
            <div>
            <label style={{paddingLeft:"0px"}}>
              <input
                type="checkbox"
                value="A"
                checked={selectedClasses[0] === 1}
                onChange={(e) => setSelectedClasses([1,0,0,0].map((bit, index) => bit ^ selectedClasses[index]))}
                onClick={(e) => setSelectedClasses([1,0,0,0].map((bit, index) => bit ^ selectedClasses[index]))}
                autoComplete="off"
              />
              <span style={{marginLeft:"5px", top: "-1px", position:"relative"}}>
              A
              </span>
            </label>
            <label style={{paddingLeft:"20px"}}>
              <input
                type="checkbox"
                value="B"
                checked={selectedClasses[1] === 1}
                onChange={(e) => setSelectedClasses([0,1,0,0].map((bit, index) => bit ^ selectedClasses[index]))}
                onClick={(e) => setSelectedClasses([0,1,0,0].map((bit, index) => bit ^ selectedClasses[index]))}
                autoComplete="off"
              />
              <span style={{marginLeft:"5px", top: "-1px", position:"relative"}}>
              B
              </span>
            </label>
            <label style={{paddingLeft:"20px"}}>
              <input
                type="checkbox"
                value="C"
                checked={selectedClasses[2] === 1}
                onChange={(e) => setSelectedClasses([0,0,1,0].map((bit, index) => bit ^ selectedClasses[index]))}
                onClick={(e) => setSelectedClasses([0,0,1,0].map((bit, index) => bit ^ selectedClasses[index]))}
                autoComplete="off"
              />
              <span style={{marginLeft:"5px", top: "-1px", position:"relative"}}>
              C
              </span>
            </label>
            <label style={{paddingLeft:"20px"}}>
              <input
                type="checkbox"
                value="D"
                checked={selectedClasses[3] === 1}
                onChange={(e) => setSelectedClasses([0,0,0,1].map((bit, index) => bit ^ selectedClasses[index]))}
                onClick={(e) => setSelectedClasses([0,0,0,1].map((bit, index) => bit ^ selectedClasses[index]))}
                autoComplete="off"
              />
              <span style={{marginLeft:"5px", top: "-1px", position:"relative"}}>
              D
              </span>
            </label>
            </div>
          </div>
          </div>
        </div>
      
        <div className="list-header">
        <div className="listview-header-grid" style={{width: "100%", marginLeft:"60px"}}>
        <div className="listview-grid-item">
          <span
          style={{color: '#9595ff', cursor:"pointer" }}
                onClick={() => {
                  setSortType('tile')
                  setSortListedPrice(false);
                  setSortListedPriceRaw(false);
                  if(sortType=='tile'){setSortAscending(!sortAscending)};
                }}>
          Tile&nbsp;
          {sortType == 'tile' ? sortAscending ? (
                <IoIosArrowUp style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowUp>
              ) : (
                <IoIosArrowDown style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowDown>
            ): null}
          </span>
        </div>
        <div className="listview-grid-item">
          <span
          style={{color: '#9595ff',cursor:"pointer"}}
                onClick={() => {
                  setSortType('mint price')
                  setSortListedPrice(false);
                  setSortListedPriceRaw(false);
                  if(sortType=='mint price'){setSortAscending(!sortAscending)};
                }}>        
              Mint&nbsp;<br></br>Price&nbsp;
              {sortType == 'mint price' ? sortAscending ? (
                <IoIosArrowUp style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowUp>
              ) : (
                <IoIosArrowDown style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowDown>
            ): null} 
            </span>
          </div>  
          <div className="listview-grid-item" >     
          <span
          style={{color: '#9595ff',  paddingLeft: "5px", cursor:"pointer"}}             
                onClick={() => {
                  setSortType('listed price')
                  setSortListedPrice(false);
                  setSortListedPriceRaw(true);
                  if(sortType=='listed price'){setSortAscending(!sortAscending)};
                }}>
              List&nbsp;<br></br>Price&nbsp;{!sortListedPriceRaw ? (<></>) : (<></>)}
          {sortType == 'listed price' ? sortAscending ? (
                <IoIosArrowUp style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowUp>
              ) : (
                <IoIosArrowDown style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowDown>
            ): null} 
            </span>
          </div>
          <div className="listview-grid-item" > 
          <span 
          style={{color: '#9595ff', paddingLeft: "15px", cursor:"pointer"}}           
                onClick={() => {
                  setSortType('price per pixel')
                  setSortListedPrice(true);
                  setSortListedPriceRaw(false);
                  if(sortType=='price per pixel'){setSortAscending(!sortAscending)};
                }}>
              Price per Pixel&nbsp;{!sortListedPrice ? (<></>) : (<></>)}
          {sortType == 'price per pixel' ? sortAscending ? (
                <IoIosArrowUp style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowUp>
              ) : (
                <IoIosArrowDown style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowDown>
            ): null} 
            </span>
          </div>
          <div className="listview-grid-item" > 
          <span
          style={{color: '#9595ff' , paddingLeft: "25px", cursor:"pointer"}}            
                onClick={() => {
                  setSortType('total pixels')
                  setSortListedPrice(false);
                  setSortListedPriceRaw(false);
                  if(sortType=='total pixels'){setSortAscending(!sortAscending)};
                }}>
              Total Pixels&nbsp;
          {sortType == 'total pixels' ? sortAscending ? (
                <IoIosArrowUp style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowUp>
              ) : (
                <IoIosArrowDown style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowDown>
            ): null} 
            </span>
          </div>
          <div className="listview-grid-item" > 
          <span 
          style={{color: '#9595ff', paddingLeft: "25px", cursor:"pointer"}}          
                onClick={() => {
                  setSortType('class')
                  setSortListedPrice(false);
                  setSortListedPriceRaw(false);
                  if(sortType=='class'){setSortAscending(!sortAscending)};
                }}>
              Class&nbsp;
          {sortType == 'class' ? sortAscending ? (
                <IoIosArrowUp style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowUp>
              ) : (
                <IoIosArrowDown style={{pointerEvents: 'all', fontSize: 18, color: 'rgb(238, 238, 238)'}} 
                onClick={() => {setSortAscending(!sortAscending);}}></IoIosArrowDown>
            ): null} 
            </span>
        </div>
        </div>
        </div>
        <div className="tile-list-info">
          {ownershipUpdated ? (
            <>
              <div className="scrollable">
                {items.map((item, index) => (
                  <div
                    className={`list-item clickable ${
                      item.name === selectedItem ? 'selected-list-item' : ''
                    }`}
                    style={{
                      backgroundColor:
                        item.status == 'Minted'
                          ? 'rgb(148, 39, 39)'
                          : item.status == 'Yours'
                          ? '#febe32'
                          : 'rgb(59, 49, 70)',
                      // 'rgba(35, 38, 68)',
                      pointerEvents: 'all',
                      color: ownership[token_dict[item.name]] == 2 ? "#000000":null,
                      border:
                        item.name === mousedOverItem ? '1px solid #ffed7a' : null,
                    }}
                    key={item.name}
                    onMouseEnter={() => {
                      setMousedOverItem(item.name);
                    }}
                    onMouseLeave={() => {
                      setMousedOverItem(null);
                    }}
                    onClick={() => {
                      setSidebar(1);
                      setTilePreview(parseInt(item.name));
                      setCurrentPrompt(null);
                      selectQueriedClone({
                        map,
                        gridOverlay,
                        sidebarState: 0,
                        setMasterTile,
                        setSidebarTitle,
                        shouldZoom: 1,
                        queryNumObject: { number: item.name },
                        setTilePreview,
                      });
                      setSelectedItem(item.name);
                    }}

                  >
                    <img src={item.image} className="item-image" style={{marginRight: "-8%"}}/>
                    <div className="item-name-info">{item.name}</div> 
                    <div className="item-name-info">{item.price}</div>
                    <div className="item-name-info">{item.listedPrice === null ? "-" : (item.listedPrice * token_dict[item.name]).toFixed(5)}</div>
                    <div className="item-name-info">{ownership[token_dict[item.name]] !== 0 ? (<>{ listedTokens.includes(token_dict[item.name].toString()) ? listedTokensPrices[token_dict[item.name]].toFixed(8) : "-"}</>) : 0.00000025.toFixed(8)}</div>                          
                    <div className="item-name-info">{token_dict[item.name]}</div>
                    <div className="item-name-info">{polygonJson.features[0].features[parseInt(item.name)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1]}</div>
                  </div>
                ))}
              </div>
              <div className="list-footer">{items.length} of 1000 Tiles</div>
            </>
          ) : (
            <div className="loading-container">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
              >
                <rect
                  className="spinner_9y7u"
                  x="1"
                  y="1"
                  rx="1"
                  width="10"
                  height="10"
                />
                <rect
                  className="spinner_9y7u spinner_DF2s"
                  x="1"
                  y="1"
                  rx="1"
                  width="10"
                  height="10"
                />
                <rect
                  className="spinner_9y7u spinner_q27e"
                  x="1"
                  y="1"
                  rx="1"
                  width="10"
                  height="10"
                />
              </svg>
            </div>
          )}
        </div>
        </div>
        </>
  );
}

export default Info_pricing;
